import React from 'react'
import { Route, Routes } from 'react-router-dom';

import Login from './component/Login/Login';
import Alumni from './component/Alumni/Alumni';
import Employer from './component/Employer/Employer';
import StudentDashboard from './component/StudentDashboard/StudentDashboard';
import TeacherDashboard from './component/TeacherDashboard/TeacherDashboard';
import AlumniDashboard from './component/AlumniDashboard/AlumniDashboard';
import EmployerDashboard from './component/EmployerDashboard/EmployerDashboard';
import TeacherFeedback from './component/TeacherFeedback/TeacherFeedback';
import SSSFeedback from './component/SSSFeedback/SSSFeedback';
import AlumniFeedback from './component/AlumniFeedback/AlumniFeedback';
import EmployerFeedback from './component/EmployerFeedback/EmployerFeedback';
import StudentInfrastructureFeedback from './component/StudentInfrastructureFeedback/StudentInfrastructureFeedback';
import CourseTransactionFeedback from './component/CourseTransactionFeedback/CourseTransactionFeedback';
import ThankYou from './component/ThankYou/ThankYou';
import ProtectedRoute from './component/ProtectedRoute/ProtectedRoute';
import ProgrammeFeedback from './component/ProgrammeFeedback/ProgrammeFeedback';
import AcademicFeedback from './component/AcademicFeedback/AcademicFeedback';
import StudentTeacherFeedback from './component/StudentTeacherFeedback/StudentTeacherFeedback';

var config = require('./config/config.json');

class App extends React.Component {
  render() {
    return (
      <>
        <Routes>
          <Route path="/" element={<Login title={config.collegeName + ' : Login'} />} exact />
          <Route path="/Alumni" element={<Alumni title={config.collegeName + ' : Alumni'} />} />
          <Route path="/Employer" element={<Employer title={config.collegeName + ' : Employer'} />} />
          <Route path="/ThankYou" element={<ThankYou title={config.collegeName + ' : Thank You'} />} />

          <Route exact path='/' element={<ProtectedRoute />}>
            <Route path="/StudentDashboard" element={<StudentDashboard title={config.collegeName + ' : Student Dashboard'} />} exact />
            <Route path="/TeacherDashboard" element={<TeacherDashboard title={config.collegeName + ' : Teacher Dashboard'} />} />
            <Route path="/AlumniDashboard" element={<AlumniDashboard title={config.collegeName + ' : Alumni Dashboard'} />} />
            <Route path="/EmployerDashboard" element={<EmployerDashboard title={config.collegeName + ' : Employer Dashboard'} />} />
            <Route path="/StudentInfrastructureFeedback" element={<StudentInfrastructureFeedback title={config.collegeName + ' : Student Infrastructure Feedback'} />} />
            <Route path="/SSSFeedback" element={<SSSFeedback title={config.collegeName + ' : Student Satisfaction Survey Feedback'} />} />
            <Route path="/AlumniFeedback" element={<AlumniFeedback title={config.collegeName + ' : Alumni Feedback'} />} />
            <Route path="/EmployerFeedback" element={<EmployerFeedback title={config.collegeName + ' : Employer Feedback'} />} />
            <Route path="/TeacherFeedback" element={<TeacherFeedback title={config.collegeName + ' : Teacher Feedback'} />} />
            <Route path="/CourseTransactionFeedback" element={<CourseTransactionFeedback title={config.collegeName + ' : Course Transaction Feedback'} />} />
            <Route path="/ProgrammeFeedback" element={<ProgrammeFeedback title={config.collegeName + ' : Programme Feedback'} />} />
            <Route path="/AcademicFeedback" element={<AcademicFeedback title={config.collegeName + ' : Academic Feedback'} />} />
            <Route path="/StudentTeacherFeedback" element={<StudentTeacherFeedback title={config.collegeName + ' : Student on Teacher Feedback'} />} />
          </Route>
        </Routes>
      </>

    )
  }
}
export default App